import { Component, Input } from '@angular/core';
import { Item } from '../../waitingnotes.component'; // ou adapte le chemin si nécessaire

@Component({
  selector: 'app-item-line',
  templateUrl: './item-line.component.html',
})
export class ItemLineComponent {
  @Input() item!: Item;

  getPaidLabel(item: Item): string {
    const paidQuantity = item.quantity - item.remainingQuantity;
    if (item.quantity === 1) {
      return 'payé';
    }
    if (item.remainingQuantity === 0 || paidQuantity > 1) {
      return `${paidQuantity} payés`;
    }
    return `${paidQuantity} payé`;
  }

  getFreeLabel(item: Item): string {
    if (item.quantity > 1) {
      return `Offerts`;
    }
    return `Offert`;
  }

}
